import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type PhotographerUploadsTabProps = {
    label: string;
};

const PhotographerUploadsRoute = '/photographer-uploads';

let routes = [PhotographerUploadsRoute];

function PhotographerUploadsTab({ label, ...props }: PhotographerUploadsTabProps) {
    function handleClick() {
        history.push(PhotographerUploadsRoute);
    }

    return (
        <BaseTab {...props} onClick={handleClick} label={label} route={PhotographerUploadsRoute} />
    );
}

function TranslatedPhotographerUploadsTab(props) {
    const label = Translate('header/nav/photographer-uploads');
    return <PhotographerUploadsTab {...props} label={label} />;
}

TranslatedPhotographerUploadsTab.routes = routes;

export default TranslatedPhotographerUploadsTab;
